import React, { useState } from 'react';
import './ActionPanel.styles.scss';
import 'primeicons/primeicons.css';

const ActionPanel: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleAction = (action: string) => {
    switch (action) {
      case 'pipeline':
        alert('Added Paracetamol 500mg Tablet to development pipeline');
        break;
      case 'scenario':
        alert('Opening pricing scenario builder...');
        break;
      case 'export':
        alert('Exporting PDF snapshot of current analysis...');
        break;
      case 'alert':
        alert('Set Alert: Choose thresholds for price changes, new approvals, or volume spikes');
        break;
      default:
        break;
    }
  };

  return (
    <div className={`action-panel ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="action-panel-header">
        {isExpanded && <h4>Actions</h4>}
        <button className="action-panel-toggle" onClick={toggleExpand} aria-label="Toggle actions">
          <i className={`pi ${isExpanded ? 'pi-times' : 'pi-bars'}`}></i>
        </button>
      </div>
      {isExpanded && (
        <div className="action-panel-content">
          <div className="action-buttons">
            <button className="action-btn primary" onClick={() => handleAction('pipeline')}>
              Add to Pipeline
            </button>
            <button className="action-btn" onClick={() => handleAction('scenario')}>
              Create Pricing Scenario
            </button>
            <button className="action-btn" onClick={() => handleAction('export')}>
              Export Snapshot
            </button>
            <button className="action-btn" onClick={() => handleAction('alert')}>
              Set Alert
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionPanel;
